const bytesToString = function (bytes, decimal) {
	if (bytes == 0) return '0 Bytes'
	
	var k = 1024,
		dm = decimal || 2,
		sizes = ['bytes', 'KB', 'MB', 'GB'],
		i = Math.floor(Math.log(bytes) / Math.log(k))
	
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export default bytesToString